import React from 'react'
import { Locale, Translation } from 'locale'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { TradingEntityAliasesAddDialog } from './TradingEntityAliasesAddDialog'

const TradingEntityAliasesToolbarComponent = (props: ModalConsumerProps) => {
  const openAliasDialog = () => {
    props.showModal(<TradingEntityAliasesAddDialog />)
  }

  return (
    <TextButton dataTestId={'TradeSplitButton-TextButton-AddTradeSplit'} type={TextButtonType.Primary} onClick={openAliasDialog}>
      {Locale.translate(Translation.TC_BUTTON_NEW_TRADING_ENTITY_ALIAS)}
    </TextButton>
  )
}

export const TradingEntityAliasesToolbar = withModal(TradingEntityAliasesToolbarComponent)
